import { useContext } from 'react';
import { ModalActionsContext, ModalStateContext } from './ModalProvider';

export const useModalActions = () => {
  const context = useContext(ModalActionsContext);
  if (!context)
    throw new Error('useModalActions must be used within ModalProvider');
  return context;
};

export const useModalState = () => {
  const context = useContext(ModalStateContext);
  if (!context)
    throw new Error('useModalState must be used within ModalProvider');
  return context;
};

const useIsModalOpen = (modalType) => {
  const modals = useContext(ModalStateContext);
  return modalType in modals;
};

const useModalProps = (modalType) => {
  const modals = useContext(ModalStateContext);
  return modals[modalType];
};

export const useModal = (modalType) => {
  const isOpen = useIsModalOpen(modalType);
  const props = useModalProps(modalType);
  const { openModal, closeModal } = useModalActions();

  return {
    isOpen,
    props,
    open: (data) => openModal(modalType, data),
    close: () => closeModal(modalType),
  };
};
